import { render, staticRenderFns } from "./AssignReturnItemDetails.vue?vue&type=template&id=276bca3f&"
import script from "./AssignReturnItemDetails.vue?vue&type=script&lang=js&"
export * from "./AssignReturnItemDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports